import { useEffect, useState } from 'react';

import { oneService } from '~services/oneService';
import { useOptions } from '~contexts/OptionsContext';

export type TransportStatus = 'connected' | 'connecting' | 'http';

/**
 * Live OneService transport status for the connection indicator. Re-evaluates
 * when the user switches transport mode and on a short poll, since the SignalR
 * connection state changes outside React (reconnects, fallback cooldown expiry).
 */
export function useTransportStatus(): TransportStatus {
  // Re-run the effect (and re-connect) whenever the preference changes.
  const { transportMode: mode } = useOptions();
  const [status, setStatus] = useState<TransportStatus>(() =>
    oneService.getTransportStatus()
  );

  useEffect(() => {
    oneService.ensureConnected();
    const tick = () => setStatus(oneService.getTransportStatus());
    tick();
    const id = window.setInterval(tick, 1200);
    return () => window.clearInterval(id);
  }, [mode]);

  return status;
}
